export default function env(name) {
  return name === 'NODE_ENV'
    ? process.env.NODE_ENV
    : process.env[`REACT_APP_${name}`];
}
